(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Accordion-Section"]) return;
  try {
    

$('document').ready(function(){
  $('.toggle').click(function(e) {
      e.preventDefault();
      $(this).parent().toggleClass('show');
      $(this).siblings('.container.inner').slideToggle(350);
      $(this).parent().siblings().removeClass('show');
      $(this).parent().siblings().find('.container.inner').slideUp(350);
  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers-2"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var carouselSelector = $('.bestseller-carousel');
    let getSliderSettings = () => {
        return {
            infinite: false,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            "responsive":[
            {
                "breakpoint":1400,
                "settings":{
                    "arrows":false,
                    "slidesToShow":3
                }
            },
            {
                "breakpoint":1024,
                "settings":{
                    "arrows":false,
                    "slidesToShow":2
                }
            },
            {
                "breakpoint":768,
                settings: "unslick"
            }
        ]       
        }
    }
    /*carouselSelector.slick(getSliderSettings());*/
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-bestsellers"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var carouselSelector = $('.bestseller-carousel');
    let getSliderSettings = () => {
        return {
            infinite: false,
            dots: false,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            "responsive":[
            {
                "breakpoint":1400,
                "settings":{
                    "arrows":false,
                    "slidesToShow":3
                }
            },
            {
                "breakpoint":1024,
                "settings":{
                    "arrows":false,
                    "slidesToShow":2
                }
            },
            {
                "breakpoint":768,
                settings: "unslick"
            }
        ]       
        }
    }
    /*carouselSelector.slick(getSliderSettings());*/
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
    var testimonialSelector = $('.testimonial-carousel');
    let testimonialSliderSettings = () => {
        return {
        "dots":false,
        "arrows":true,
        "slidesToShow":3,
        "centerMode":true,
        "centerPadding":"60px",
        "responsive":[
            {
                "breakpoint":1400,
                "settings":{
                    "arrows":true,
                    "centerMode":true,
                    "centerPadding":"40px",
                    "slidesToShow":2
                }
            },
            {
                "breakpoint":1024,
                "settings":{
                    "arrows":true,
                    "centerMode":true,
                    "centerPadding":"40px",
                    "slidesToShow":1
                }
            },
            {
                "breakpoint":768,
                "settings":{
                    "arrows":false,
                    "centerMode":true,
                    "centerPadding":"20px",
                    "slidesToShow": 1
                }
            }
        ]
        }
    }
    testimonialSelector.slick(testimonialSliderSettings());
});
$(document).ready(function() {
  $('#play-video').on('click', function(ev) {
    $("#video")[0].src += "&autoplay=1";
    ev.preventDefault();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-perk"]) return;
  try {
    
$(document).ready(function(){
    function unifyHeight(){
        $('.text-container').height($('.image-container img').height() - 2);
    }
    unifyHeight();
    window.resize = unifyHeight();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-doctors-new-section1"]) return;
  try {
    
  
  $(function() {
  var showTotalChar = 1200,
    showChar = "Read More",
    hideChar = "Read Less";
  $('.show').each(function() {
    var content = $(this).html();
    if (content.length > showTotalChar) {
      var con = content.substr(0, showTotalChar);
      var hcon = content.substr(showTotalChar, content.length - showTotalChar);
      var txt = con + '<span class="dots">...</span><span class="morectnt"><span>' + hcon + '</span>&nbsp;&nbsp;<a href="" class="showmoretxt">' + showChar + '</a></span>';
      $(this).html(txt);
    }
  });
  $(".showmoretxt").click(function() {
    if ($(this).hasClass("sample")) {
      $(this).removeClass("sample");
      $(this).text(showChar);
    } else {
      $(this).addClass("sample");
      $(this).text(hideChar);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-doctors-new-section3"]) return;
  try {
    
  
  $(function() {
  var showTotalChar = 1200,
    showChar = "Read More",
    hideChar = "Read Less";
  $('.show').each(function() {
    var content = $(this).html();
    if (content.length > showTotalChar) {
      var con = content.substr(0, showTotalChar);
      var hcon = content.substr(showTotalChar, content.length - showTotalChar);
      var txt = con + '<span class="dots">...</span><span class="morectnt"><span>' + hcon + '</span>&nbsp;&nbsp;<a href="" class="showmoretxt">' + showChar + '</a></span>';
      $(this).html(txt);
    }
  });
  $(".showmoretxt").click(function() {
    if ($(this).hasClass("sample")) {
      $(this).removeClass("sample");
      $(this).text(showChar);
    } else {
      $(this).addClass("sample");
      $(this).text(hideChar);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-flatiron"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-miami"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false, 
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-ues"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-westchester"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false, 
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-westhartford"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-providers-wheights"]) return;
  try {
    

$('.our-providers-repeater').slick({
  dots: false, 
  arrows: true,
  infinite: true,
  speed: 200,
  slidesToShow: 3,
  slidesToScroll: 1, 
  // prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-prev-black.png?v=1683750835"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%204.png?v=1698236331"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/arrow-next-black.png?v=1683750834"></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0012/0196/3108/t/51/assets/Path%203.png?v=1698236399"></button>',
  responsive: [
    { 
      breakpoint: 1024, 
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();
})();
